import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import type { IClassNameProps } from '@bem-react/core';

import { cnCheckbox } from '../Checkbox.cn';

import './Checkbox-Box.css';

// @analyze-exports:disable
export type CheckboxBoxProps = PropsWithChildren<IClassNameProps>;

// @analyze-exports:disable
export const CheckboxBox: FC<CheckboxBoxProps> = ({ className, children, ...props }) => (
    <span {...props} className={cnCheckbox('Box', null, [className])}>
        {children}
    </span>
);
